<script setup lang="ts">
import FilterPremium from '../@components/Premium/index.vue'
import FilterInterval from '../@components/Interval/index.vue'
import FilterSort from '../@components/Sort/index.vue'
import FilterItemType from '../@components/ItemType/index.vue'
import FilterElementalType from '../@components/ElementalType/index.vue'
import type { ElementalType, ElementalTypeEnum, ViewType } from '~~/src/types/elemental'

interface IProps {
  defaultLayout?: ViewType
  elementalTypes?: ElementalType[]
  selectedElementalTypes?: ElementalTypeEnum[]
}
interface IEmits {
  (e: 'changeLayout', tab: ViewType): void
}

const props = withDefaults(defineProps<IProps>(), {
  selectedElementalTypes: () => [],
})
defineEmits<IEmits>()
const { defaultLayout, elementalTypes, selectedElementalTypes } = toRefs(props)

const { colors } = useTheme()

const containerRef = ref()
const { width } = useElementSize(containerRef)
const isSmall = computed(() => width.value < 768)

const typeChange = (type: ElementalTypeEnum | null) => {
  if (!selectedElementalTypes.value)
    selectedElementalTypes.value = []

  if (!type) {
    selectedElementalTypes.value.splice(0, selectedElementalTypes.value.length)
    return
  }

  const index = selectedElementalTypes.value.indexOf(type)
  if (index > -1)
    selectedElementalTypes.value.splice(index, 1)
  else
    selectedElementalTypes.value.push(type)
}
</script>

<script lang="ts">
export default defineComponent({
  name: 'PromptFiltersVisual',
})
</script>

<template>
  <div :ref="containerRef" flex="~ nowrap" relative z-2 :class="isSmall ? 'items-start gap-2' : 'items-center gap-x-5'">
    <div flex="~ nowrap" gap-5 gap-y-2 :class="isSmall ? 'mt-1' : ''">
      <div>
        <AppTabs :default-tab="defaultLayout === 'grid' ? 0 : 1" :color="colors.white" variant="outline-soft" @select-tab="(tab: string) => $emit('changeLayout', tab as ViewType)">
          <AppTab name="grid" />
          <template #tab-grid>
            <div flex center w-7 h-7>
              <div i-material-symbols:grid-on-sharp />
            </div>
          </template>

          <AppTab name="list" />
          <template #tab-list>
            <div flex center w-7 h-7>
              <div i-material-symbols:menu />
            </div>
          </template>
        </AppTabs>
      </div>
    </div>

    <div flex="~ wrap" flex-grow-1 items-center :class="isSmall ? 'justify-end gap-2' : 'justify-between gap-7'">
      <div flex="~ wrap" items-center :class="isSmall ? 'justify-end gap-2' : 'gap-7'">
        <div class="flex items-center" :class="isSmall ? 'gap-2' : 'gap-7'">
          <FilterInterval />
          <FilterItemType />
        </div>

        <FilterElementalType
          v-if="!isSmall"
          :elemental-types="elementalTypes"
          :selected-elemental-types="selectedElementalTypes"
          @type-change="typeChange"
        />
      </div>

      <div flex="~ nowrap" items-center :class="isSmall ? 'gap-2' : 'gap-7'">
        <FilterPremium />
        <FilterSort :order-by-newest="true" :order-by-uses="true" :order-by-upvotes="true" />
      </div>

      <FilterElementalType
        v-if="isSmall"
        :elemental-types="elementalTypes"
        :selected-elemental-types="selectedElementalTypes"
        @type-change="typeChange"
      />
    </div>
  </div>
</template>
